import $ from "jquery";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { Treebeard } from "react-treebeard";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Theme {
    tree = {
        base: {
            listStyle: "none",
            backgroundColor: "#FFFFFF",
            margin: 0,
            padding: 0,
            color: "#DDDDDD",
            fontFamily: "lucida grande ,tahoma,verdana,arial,sans-serif",
            fontSize: "12px",
        },
        node: {
            base: {
                position: "relative",
            },
            link: {
                cursor: "pointer",
                position: "relative",
                padding: "0px 5px",
                display: "block",
            },
            activeLink: {
                background: "#DDDDDD",
            },
            toggle: {
                base: {
                    position: "relative",
                    display: "inline-block",
                    verticalAlign: "top",
                    marginLeft: "-5px",
                    height: "18px",
                    width: "18px",
                },
                wrapper: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    margin: "-7px 0 0 -7px",
                    height: "10px",
                },
                height: 12,
                width: 12,
                arrow: {
                    fill: "#000000",
                    strokeWidth: 0,
                },
            },
            header: {
                base: {
                    display: "inline-block",
                    verticalAlign: "top",
                    color: "#000000",
                },
                connector: {
                    width: "2px",
                    height: "12px",
                    borderLeft: "solid 2px black",
                    borderBottom: "solid 2px black",
                    position: "absolute",
                    top: "0px",
                    left: "-21px",
                },
                title: {
                    lineHeight: "12px",
                    verticalAlign: "middle",
                },
            },
            subtree: {
                listStyle: "none",
                paddingLeft: "19px",
            },
            loading: {
                color: "#E2C089",
            },
        },
    };
}

class Sales extends Component {
    GetNode(t) {
        var node = {
            id: t.id,
            name: t.name,
            opened: false,
            selected: false,
            children: [],
        };
        if (t.childs)
            for (var iter = 0; iter < t.childs.length; iter++) {
                var i = t.childs[iter];
                node.children.push(this.GetNode(i));
            }

        return node;
    }
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        var sid = Context.GetContext().Sid;

        var tree = Comm.GetArticleTree({ session: sid });
        var treeData = [];
        for (var t of tree) {
            treeData.push(this.GetNode(t));
        }

        this.state = {
            TreeData: treeData,
            DialogMode: "none",
            BagInfo: [],
        };

        this.onToggle = this.onToggle.bind(this);
        this.ContragentsDialog = this.ContragentsDialog.bind(this);
        this.SelectContragent = this.SelectContragent.bind(this);
        this.AddQuantity = this.AddQuantity.bind(this);
        this.NullQuantity = this.NullQuantity.bind(this);
        this.EditQuantity = this.EditQuantity.bind(this);
        this.DeleteQuantity = this.DeleteQuantity.bind(this);
        this.CancelEditQuantities = this.CancelEditQuantities.bind(this);
        this.Save = this.Save.bind(this);
    }

    onToggle(node, toggled) {
        // if (this.state.cursor) {
        //     this.state.cursor.active = false;
        // }
        this.setState(prevState => {
            let cursor = prevState.cursor;
            if (cursor) {
                cursor = {...cursor, active: false};
            }
            return {cursor};
        });
        node.active = true;
        if (node.children) {
            node.toggled = toggled;
        }
        this.setState({ cursor: node });
        this.setState({
            SelectedArticleName: node.name,
            SelectedArticleId: node.id,
        });
    }

    ContragentsDialog() {
        var sid = Context.GetContext().Sid;

        var contragents = Comm.Partners(sid);

        this.setState({
            DialogMode: "contragents",
            Contragents: contragents,
        });
    }

    SelectContragent(obj) {
        if (obj === null) {
            this.setState({
                DialogMode: "none",
            });
        } else {
            this.setState({
                DialogMode: "none",
                SelectedContragentId: obj.id,
                SelectedContragentName: obj.name,
            });
        }
    }

    GetRow(id) {
        var info = this.state.BagInfo;
        var row = null;
        for (var r of info) {
            if (r.id === id) {
                row = r;
                break;
            }
        }
        return row;
    }

    AddQuantity() {
        if (!this.state.SelectedArticleId) return;
        var qty = parseInt($("#tbCount").val(), 10);
        var weight = parseInt($("#tbWeight").val(), 10);
        if (qty === 0 || weight === 0) return;
        var info = this.state.BagInfo;
        var row = this.GetRow(this.state.SelectedArticleId);
        if (row === null) {
            row = {
                id: this.state.SelectedArticleId,
                name: this.state.SelectedArticleName,
                bags: [
                    {
                        qty: qty,
                        weight: weight,
                    },
                ],
            };
            info.push(row);
        } else {
            row.bags.push({
                qty: qty,
                weight: weight,
            });
        }

        this.setState({ BagInfo: info });
    }

    static GetQuantity(obj) {
        var qty = 0;
        for (var item of obj.bags) {
            qty += item.qty;
        }
        return qty;
    }
    static GetWeight(obj) {
        var qty = 0;
        for (var item of obj.bags) {
            qty += item.qty * item.weight;
        }
        return qty;
    }

    NullQuantity(obj) {
        var info = this.state.BagInfo;
        var row = this.GetRow(obj.id);
        row.bags = [];

        this.setState({ BagInfo: info });
    }

    EditQuantity(obj) {
        this.setState({
            SelectedArticle: obj,
            DialogMode: "quantities",
        });
    }

    DeleteQuantity(obj) {
        var row = this.GetRow(this.state.SelectedArticle.id);
        for (var i = 0; i < row.bags.length; i++)
            if (row.bags[i].qty === obj.qty && row.bags[i].weight === obj.weight) {
                row.bags.splice(i, 1);
                break;
            }

        var info = this.state.BagInfo;

        this.setState({
            SelectedArticle: null,
            BagInfo: info,
            DialogMode: "none",
        });
    }

    CancelEditQuantities(obj) {
        this.setState({
            SelectedArticle: null,
            DialogMode: "none",
        });
    }

    Save() {
        var info = this.state.BagInfo;
        var sid = Context.GetContext().Sid;
        var saleData = { items: [] };
        for (var row of info) {
            var item = {
                name: row.name,
                qty: Sales.GetWeight(row),
                packets: [],
            };
            for (var i = 0; i < row.bags.length; i++)
                for (var j = 0; j < row.bags[i].qty; j++) item.packets.push(row.bags[i].weight);
            saleData.items.push(item);
        }
        var data = {
            session: sid,
            partner: this.state.SelectedContragentName,
            data: JSON.stringify(saleData),
        };

        Comm.SaveSale(data);

        this.setState({
            SelectedArticle: null,
            BagInfo: [],
            DialogMode: "none",
        });
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;

        var t = new Theme();

        return Context.HasRight("rsales") ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("sales")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-4">
                            <Treebeard
                                data={this.state.TreeData}
                                onToggle={this.onToggle}
                                style={t}
                            ></Treebeard>
                        </div>

                        {this.state.DialogMode === "none" ? (
                            <div className="col-md-8">
                                <div className="col-md-12">
                                    {Context.HasRight("esales") &&
                                    this.state.SelectedArticleName &&
                                    this.state.SelectedContragentName ? (
                                        <button className="btn btn-primary" onClick={() => this.Save()}>
                                            {Translation.Trans("save")}
                                        </button>
                                    ) : null}
                                </div>
                                <div className="col-md-12">
                                    {Translation.Trans("selectedarticle")}:{" "}
                                    <strong>{this.state.SelectedArticleName}</strong>
                                </div>
                                <div className="col-md-12">
                                    {Translation.Trans("contragent")}
                                    <button className="button" onClick={() => this.ContragentsDialog()}>
                                        ...
                                    </button>
                                    : <strong>{this.state.SelectedContragentName}</strong>
                                </div>
                                <div className="col-md-12">
                                    <div className="col-md-6">
                                        <label for="tbCount" className="control-label">
                                            {Translation.Trans("count")}
                                        </label>
                                        <input
                                            type="number"
                                            min="1"
                                            step="1"
                                            id="tbCount"
                                            className="form-control"
                                            defaultValue="1"
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label for="tbWeight" className="control-label">
                                            {Translation.Trans("weight")}
                                        </label>
                                        <input
                                            type="number"
                                            min="1"
                                            step="1"
                                            id="tbWeight"
                                            className="form-control"
                                            defaultValue="1"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="col-md-2">
                                        <button
                                            className="btn btn-default pull-bottom"
                                            onClick={() => this.AddQuantity()}
                                        >
                                            <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>{Translation.Trans("name")}</th>
                                                <th>{Translation.Trans("count")}</th>
                                                <th>{Translation.Trans("weight")}</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.BagInfo.map((obj) => (
                                                <tr>
                                                    <td>{obj.name}</td>
                                                    <td>{Sales.GetQuantity(obj)}</td>
                                                    <td>{Sales.GetWeight(obj)}</td>
                                                    <td>
                                                        <button
                                                            className="btn btn-default"
                                                            onClick={() => this.NullQuantity(obj)}
                                                        >
                                                            0
                                                        </button>
                                                    </td>
                                                    <td>
                                                        <button
                                                            className="btn btn-default"
                                                            onClick={() => this.EditQuantity(obj)}
                                                        >
                                                            -
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        ) : null}
                        {this.state.DialogMode === "contragents" ? (
                            <div className="col-md-8">
                                <button className="btn btn-primary" onClick={() => this.SelectContragent()}>
                                    {Translation.Trans("cancel")}
                                </button>
                                <table className="table table-striped">
                                    <tbody>
                                        {this.state.Contragents.map((obj) => (
                                            <tr>
                                                <td width="100%">
                                                    <a
                                                        onClick={() => this.SelectContragent(obj)}
                                                        className="pointhand"
                                                    >
                                                        {obj.name}
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : null}
                        {this.state.DialogMode === "quantities" ? (
                            <div className="col-md-8">
                                <button
                                    className="btn btn-primary"
                                    onClick={() => this.CancelEditQuantities()}
                                >
                                    {Translation.Trans("cancel")}
                                </button>
                                <table className="table table-striped">
                                    <tbody>
                                        {this.state.SelectedArticle.bags.map((obj) => (
                                            <tr>
                                                <td>
                                                    <a
                                                        onClick={() => this.DeleteQuantity(obj)}
                                                        className="pointhand"
                                                    >
                                                        {obj.qty} / {obj.weight}
                                                    </a>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }
}

export default Sales;



// WEBPACK FOOTER //
// ./src/pages/sales.js